import { useMutation, useQuery } from '@tanstack/react-query'
import { api, unwrap, type Me, type Session } from './client'
import { storeToken } from './session'

export const meKey = ['me'] as const

export function useMe() {
  return useQuery<Me>({
    queryKey: meKey,
    queryFn: async () => unwrap(await api.GET('/me')),
  })
}

export function useRequestLoginCode() {
  return useMutation({
    mutationFn: async (email: string) => {
      const res = await api.POST('/auth/otp/request', { body: { email } })
      if (!res.response.ok) unwrap(res)
    },
  })
}

export function useVerifyLoginCode() {
  return useMutation({
    mutationFn: async (input: { email: string; code: string }): Promise<Session> => {
      const session = unwrap(await api.POST('/auth/otp/verify', { body: input }))
      storeToken(session.token)
      return session
    },
  })
}
